/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function SecondaryStructure(type, key, elements, getIndex) {
    return { type: type, key: key, elements: elements, getIndex: getIndex };
}
export { SecondaryStructure };
//# sourceMappingURL=seconday-structure.js.map